import React, { createContext, useContext, useEffect } from 'react';
import usePlatformUserTermSearch, { TUsePlatformUserTermSearch } from '../hooks/usePlatformUserTermSearch';

type TProviderManageLogs = { children: React.ReactNode };

type TProviderManageLogsContext = {
  searchPlatformTermUser: TUsePlatformUserTermSearch;
  onRetryWidthDelay: (timeout?: number) => void;
};

const ManageLogsContext = createContext(undefined) as React.Context<TProviderManageLogsContext | undefined>;

export const useManageLogs = (): TProviderManageLogsContext => {
  const context = useContext(ManageLogsContext);
  if (!context) throw new Error('useManageLogs must be used inside scope ManageLogsProvider');
  return context;
};

const ManageLogsProvider: React.FC<TProviderManageLogs> = ({ children }: TProviderManageLogs) => {
  const searchPlatformTermUser = usePlatformUserTermSearch();

  const onRetryWidthDelay = (timeout = 1500) => {
    setTimeout(() => {
      searchPlatformTermUser.onRetry && searchPlatformTermUser.onRetry();
    }, timeout);
  };
  useEffect(() => {
    searchPlatformTermUser.handleOnChangeCriteria({
      page: 0,
      pageSize: 10,
    });
  }, []);

  const value = { searchPlatformTermUser, onRetryWidthDelay };

  return <ManageLogsContext.Provider value={value}>{children}</ManageLogsContext.Provider>;
};

export default ManageLogsProvider;
